import {useQuery} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {NavigateFunction, useNavigate} from 'react-router'

import {QueryKeyName, getLocationsStats} from '../../common/backend'
import {handleError, retryFunction} from '../apiErrorHandler'

export const useAllLocationsStats = () => {
  const navigate: NavigateFunction = useNavigate()
  const result = useQuery({
    queryKey: [QueryKeyName.GetLocationsStats],
    queryFn: () => getLocationsStats(),
    staleTime: Infinity,
    retry: retryFunction
  })

  const error: AxiosError | null = result.error
  if (error) {
    handleError(error, navigate)
  }

  return result
}
